import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { CText } from '../common';
import { FiShield, FiLock, FiHeadphones, FiStar } from 'react-icons/fi';

const SocialProof: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.theme);

  const testimonials = [
    {
      quote: 'Copilot saved me hours of research. It finds insights I would have missed!',
      name: 'Amit K.',
      location: 'Mumbai',
    },
    {
      quote: 'Found 3 multibagger stocks through Buckets. Best investment decision ever.',
      name: 'Priya S.',
      location: 'Bangalore',
    },
    {
      quote: 'Expert advice was worth every rupee. Finally confident about my portfolio.',
      name: 'Raj M.',
      location: 'Delhi',
    },
  ];

  const trustBadges = [
    { icon: FiShield, label: 'SEBI Registered' },
    { icon: FiLock, label: '256-bit Encryption' },
    { icon: FiHeadphones, label: '24/7 Support' },
  ];

  return (
    <div className="mb-6">
      {/* Header */}
      <div className="text-center mb-4">
        <CText type="M16" color={colors.textColor} style={{ fontWeight: 600 }}>
          Trusted by 50,000+ Indian Investors
        </CText>
      </div>

      {/* Testimonials */}
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-hide mb-4">
        {testimonials.map((testimonial, idx) => (
          <div
            key={idx}
            className="flex-shrink-0 w-64 p-4 rounded-2xl card-shadow"
            style={{
              backgroundColor: colors.cardBackground || colors.inputBackground,
              border: `1px solid ${colors.borderColor}`,
            }}
          >
            {/* Stars */}
            <div className="flex gap-0.5 mb-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <span key={star}>
                  {React.createElement(FiStar as any, {
                    size: 14,
                    fill: '#FFB800',
                    color: '#FFB800',
                  })}
                </span>
              ))}
            </div>

            {/* Quote */}
            <CText type="r12" color={colors.textColor} style={{ lineHeight: 1.5 }}>
              "{testimonial.quote}"
            </CText>

            {/* Author */}
            <div className="mt-3 flex items-center gap-2">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold"
                style={{ backgroundColor: colors.primary, color: '#fff' }}
              >
                {testimonial.name.charAt(0)}
              </div>
              <div>
                <CText type="M12" color={colors.textColor} style={{ fontWeight: 500 }}>
                  {testimonial.name}
                </CText>
                <CText type="r10" color={colors.grayScale500}>
                  {testimonial.location}
                </CText>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Trust Badges */}
      <div
        className="flex items-center justify-center gap-4 p-3 rounded-xl"
        style={{
          backgroundColor: colors.backgroundColor,
          border: `1px solid ${colors.borderColor}`,
        }}
      >
        {trustBadges.map((badge, idx) => (
          <div key={idx} className="flex items-center gap-1.5">
            {React.createElement(badge.icon as any, { size: 14, color: colors.grayScale500 })}
            <CText type="r10" color={colors.grayScale500} style={{ fontWeight: 500 }}>
              {badge.label}
            </CText>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialProof;
